import React, { useEffect, useState } from 'react'
import ProviderAvailabilityTabs from './provider-availability-tabs/ProviderAvailabilityTabs';

const ProviderDetails = (props) => {
    const [activeIndex, setActiveIndex] = useState(0)
    const [provider, setProvider] = useState(props.provider)
    useEffect(() => {
        if (props.provider) {
            setProvider(props.provider)
        }
    }, [props.provider])

    return (
        <div className='d-flex row m-0 p-0'>
            <h5 className='bg-faded p-3 mb-0 text-center'>
                {provider?.firstName} {provider?.lastName}
            </h5>
            <ProviderAvailabilityTabs id={provider?.id} />
        </div>
    )
}

export default ProviderDetails